import { useVideo } from '../../../../context/videoContext';
import { useParticipantTracks } from '../../../../helpers/video/useParticipantTracks';
import { calibrationConstants } from '../../../../helpers/calibration-constants';
import { MobileVideo } from '.';
import { Tile, RemoteTileStatus, ReconnectingBanner } from './VideoTileStatus';

// The other participant. Shows connection state instead of an endless spinner, and a
// banner while Twilio is reconnecting (the last frame stays visible underneath).
const RemoteVideo = ({ disableBorderRadius }) => {
  const { participants, connectionStatus, connectionError, retry } = useVideo();
  const { videoTrack, isVideoEnabled } = useParticipantTracks(participants || null);

  return (
    <Tile disableBorderRadius={disableBorderRadius} radius={calibrationConstants.VIDEO_BORDER_RADIUS} data-testid='remote-video-tile'>
      {participants && <MobileVideo participant={participants} disableBorderRadius={disableBorderRadius} />}
      <RemoteTileStatus
        connectionStatus={connectionStatus}
        connectionError={connectionError}
        participant={participants}
        hasVideo={Boolean(videoTrack)}
        isVideoEnabled={isVideoEnabled}
        onRetry={retry}
      />
      {connectionStatus === 'reconnecting' && <ReconnectingBanner />}
    </Tile>
  );
};

export default RemoteVideo;
